import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FiPieChart } from "react-icons/fi";
import { IoIosNotifications } from "react-icons/io";
import { IoSettingsOutline } from "react-icons/io5";
import { MdManageAccounts, MdOutlineWorkspacePremium } from "react-icons/md";
import { FaUsers } from "react-icons/fa";
import { Server } from "lucide-react";
import { CiLogout } from "react-icons/ci";

const MenuList = ({ onMenuItemClick }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("tokenTimestamp");
    localStorage.removeItem("adminData");
    localStorage.removeItem("rememberedEmail");
    navigate("/login");
    if (onMenuItemClick) {
      onMenuItemClick();
    }
  };

  return (
    <ul className="space-y-3 lg:mt-5">
      <li>
        <NavLink
          to="/dashboard"
          className={({ isActive }) =>
            `flex items-center gap-3 py-2 mx-2 px-5 rounded transition duration-700 ${
              isActive
                ? "bg-[#000] text-white"
                : "text-[#838383] hover:bg-[#838383] hover:text-white"
            }`
          }
          onClick={onMenuItemClick}
        >
          <FiPieChart className="text-2xl" />
          Overview
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/Subscribers"
          className={({ isActive }) =>
            `flex items-center gap-3 py-2 mx-2 px-5 rounded transition duration-700 ${
              isActive
                ? "bg-[#000] text-white"
                : "text-[#838383] hover:bg-[#838383] hover:text-white"
            }`
          }
          onClick={onMenuItemClick}
        >
          <MdOutlineWorkspacePremium className="text-2xl" />
          Subscribers
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/users"
          className={({ isActive }) =>
            `flex items-center gap-3 py-2 mx-2 px-5 rounded transition duration-700 ${
              isActive
                ? "bg-[#000] text-white"
                : "text-[#838383] hover:bg-[#838383] hover:text-white"
            }`
          }
          onClick={onMenuItemClick}
        >
          <FaUsers className="text-2xl" />
          Users
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/notifications"
          className={({ isActive }) =>
            `flex items-center gap-3 py-2 mx-2 px-5 rounded transition duration-700 ${
              isActive
                ? "bg-[#000] text-white"
                : "text-[#838383] hover:bg-[#838383] hover:text-white"
            }`
          }
          onClick={onMenuItemClick}
        >
          <IoIosNotifications className="text-2xl" />
          Notifications
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/platforms"
          className={({ isActive }) =>
            `flex items-center gap-3 py-2 mx-2 px-5 rounded transition duration-700 ${
              isActive
                ? "bg-[#000] text-white"
                : "text-[#838383] hover:bg-[#838383] hover:text-white"
            }`
          }
          onClick={onMenuItemClick}
        >
          <Server size={20} className="text-2xl" />
          Platforms
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/Settings"
          className={({ isActive }) =>
            `flex items-center gap-3 py-2 mx-2 px-5 rounded transition duration-700 ${
              isActive
                ? "bg-[#000] text-white"
                : "text-[#838383] hover:bg-[#838383] hover:text-white"
            }`
          }
          onClick={onMenuItemClick}
        >
          <IoSettingsOutline size={20} className="text-2xl" />
          Settings MGT
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/AdminManagement"
          className={({ isActive }) =>
            `flex items-center gap-3 py-2 mx-2 px-5 rounded transition duration-700 ${
              isActive
                ? "bg-[#000] text-white"
                : "text-[#838383] hover:bg-[#838383] hover:text-white"
            }`
          }
          onClick={onMenuItemClick}
        >
          <MdManageAccounts  size={20} className="text-2xl" />
          Admin MGT
        </NavLink>
      </li>
      <li>
        <button
          onClick={handleLogout}
          className="flex items-center gap-3 py-2 mx-2 px-5 rounded transition duration-700 text-[#838383] hover:bg-[#838383] hover:text-white w-full text-left"
        >
          <CiLogout className="text-2xl" />
          Logout
        </button>
      </li>
    </ul>
  );
};

export default MenuList;
